<template>
  <div>
    <merge-layout
      v-model="configs"
      :items="configs"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :properties="properties"
      :status="configs.status"
      :img="mergeImg"
      :mergeRunning="mergeRunning"
      :imgLoading="imgLoading"
      @click:save="save"
    >
      <template #actions v-if="configs.merger_id">
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </merge-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import MergeLayout from '@/layout/MergeLayout'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Merge',
  components: {
    MergeLayout
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      serversLoading: false,
      mergeRunning: false,
      imgLoading: false,
      configs: {},
      properties: {},
      status: '',
      mergeImg: ''
    }
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({
        name: 'merge',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
    if (this.$route.query.type !== undefined || this.$route.params.merger_id !== undefined) {
      this.getConfig()
    } else {
      this.$router.push({
        name: 'merge',
        params: {
          server_id: this.$route.params.server_id
        }
      })
    }
  },
  methods: {
    ...mapActions('general', ['setTitle']),
    ...mapActions('general', ['setServerName']),
    save() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/merger`
      this.configs.name = this.title
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          server_id: this.$route.params.server_id,
          config: this.configs
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'mergers',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },

    getConfig() {
      const body = {
        server_id: this.$route.params.server_id
      }
      if (this.$route.query.type !== undefined) {
        body.type = this.$route.query.type
      }
      if (this.$route.params.merger_id !== undefined) {
        body.merger_id = this.$route.params.merger_id
      }
      const searchParams = new URLSearchParams(body)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/merger?${searchParams}`
      this.serversLoading = true
      return fetch(url, {
        method: 'GET',
        credentials: 'include'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(data => {
          this.configs = data.config
          this.properties = data.properties

          this.setTitle(this.configs.name)
          this.setServerName(data.server_name)


        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.serversLoading = false
        })
    },
    onDelete() {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/merger/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          merger_ids: [this.configs.merger_id]
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$router.push({
            name: 'mergers',
            params: {
              server_id: this.$route.params.server_id
            }
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: this.configs.name
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.onDelete()
            .then(() => {
              this.$notify({
                message: this.$t('notification.removed', {
                  msg: this.configs.name
                }),
                type: 'success'
              })
            })
            .finally(() => {
              this.serversLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>

